export const webAppVersion = '1.2.1';

// Same French legal pages the B2C surfaces link to (user-web-app `locales/fr.ts`,
// user-mobile-app `lib/auth/region.ts`, chrome-extension `locales/fr.ts`). The previous
// hellojoko.com paths 404 since the marketing site moved to joko.com.
export const termsOfServiceLink = 'https://www.joko.com/fr/tos';
export const privacyPolicyLink = 'https://www.joko.com/fr/privacy-policy';
